import { c as _c } from "react/compiler-runtime";
import type * as v from 'valibot';
import type { StructuredContentDocument } from '../../hydration/types';
import type { marketplaceFieldSCSchema } from './schema';
export type MarketplaceFieldProps = StructuredContentDocument<v.InferInput<typeof marketplaceFieldSCSchema>>;
export const MarketplaceField = t0 => {
  const $ = _c(2);
  const {
    props
  } = t0;
  let t1;
  if ($[0] !== props.marketplaceField.value) {
    t1 = <>{props.marketplaceField.value}</>;
    $[0] = props.marketplaceField.value;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};